require('./globals')

// Intialize App
require('./react/app')
